module.exports = __webpack_public_path__ + "img/PowerArmor.e1ad6400.gif";